import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CellProjectComponent} from './cell/cell-project/cell-project.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CellPopoverComponent} from './cell/cell-popover/cell-popover.component';
import {CellFrequencySupportComponent} from './cell/cell-frequency-support/cell-frequency-support.component';
import {NgxDatatableModule} from '@almaobservatory/ngx-datatable';
import {CellPublicationsComponent} from './cell/cell-publications/cell-publications.component';
import {CellAsdmsComponent} from './cell/cell-asdms/cell-asdms.component';
import {CellObservationsComponent} from './cell/cell-observations/cell-observations.component';
import {CellPublicationComponent} from './cell/cell-publication/cell-publication.component';
import {CellProjectsComponent} from './cell/cell-projects/cell-projects.component';
import {CellReleaseDateComponent} from './cell/cell-release-date/cell-release-date.component';
import {ReleaseIsNotPublicPipePipe} from './pipes/release-date-is-not-public.pipe';
import {ReleaseDatePipe} from './pipes/release-date.pipe';
import {UnitsFormatterPipe} from './pipes/units-formatter.pipe';
import {
  ColumnsPickerContainerComponent
} from './columns-picker/columns-picker-container/columns-picker-container.component';
import {ExportContainerComponent} from './export/export-container/export-container.component';
import {SampContainerComponent} from './samp/samp-container/samp-container.component';
import {ColumnContainerComponent} from './column/column-container/column-container.component';
import {ColumnFilterInputComponent} from './column/column-filter-input/column-filter-input.component';
import {ColumnUnitsComponent} from './column/column-units/column-units.component';
import {CellContainerComponent} from './cell/cell-container/cell-container.component';
import {ColumnFilterComponent} from './columns-filters/column-filter/column-filter.component';
import {TableContainerComponent} from './table-container/table-container.component';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {AsaxCommonModule} from 'asax-common';
import {HighlightPipe} from './pipes/highlight.pipe';
import {
  CellSimilarityContainerComponent
} from './cell/cell-similarity/cell-similarity-container/cell-similarity-container.component';
import {
  CellSimilarityForProjectComponent
} from './cell/cell-similarity/cell-similarity-for-project/cell-similarity-for-project.component';
import {
  CellSimilarityForPublicationComponent
} from './cell/cell-similarity/cell-similarity-for-publication/cell-similarity-for-publication.component';
import {
  CellSimilarityForObservationComponent
} from './cell/cell-similarity/cell-similarity-for-observation/cell-similarity-for-observation.component';
import {
  CellPreviewsContainerComponent
} from './cell/cell-previews/cell-previews-container/cell-previews-container.component';
import {CellPreviewComponent} from './cell/cell-previews/cell-preview/cell-preview.component';
import {NgBytesPipeModule, NgTruncatePipeModule} from 'angular-pipes';
import {FrequencyTypePipe} from './pipes/frequency-type.pipe';
import {FrequencySupportTextPipe} from './pipes/frequency-support-text.pipe';
import {DragulaModule} from "ng2-dragula";
import { CellSimilarityTextComponent } from './cell/cell-similarity/cell-similarity-text/cell-similarity-text.component';


@NgModule({
  declarations: [
    CellProjectComponent,
    CellPopoverComponent,
    CellFrequencySupportComponent,
    CellPublicationsComponent,
    CellAsdmsComponent,
    CellObservationsComponent,
    CellPublicationComponent,
    CellProjectsComponent,
    CellContainerComponent,
    CellReleaseDateComponent,
    ReleaseIsNotPublicPipePipe,
    ReleaseDatePipe,
    UnitsFormatterPipe,
    ColumnContainerComponent,
    ColumnFilterInputComponent,
    ColumnUnitsComponent,
    ColumnFilterComponent,
    ColumnsPickerContainerComponent,
    ExportContainerComponent,
    SampContainerComponent,
    TableContainerComponent,
    HighlightPipe,
    CellSimilarityContainerComponent,
    CellSimilarityForProjectComponent,
    CellSimilarityForPublicationComponent,
    CellSimilarityForObservationComponent,
    CellSimilarityTextComponent,
    CellPreviewsContainerComponent,
    CellPreviewComponent,
    FrequencyTypePipe,
    FrequencySupportTextPipe
  ],
  imports: [
    FormsModule,
    BrowserModule,
    NgxDatatableModule,
    CommonModule,
    NgbModule,
    AsaxCommonModule,
    NgBytesPipeModule,
    NgTruncatePipeModule,
    DragulaModule.forRoot()
  ],
  exports: [
    TableContainerComponent
  ]
})
export class SearchTableModule {
}
